import { DURATIONS, type Duration } from '../../shared/types'

export const DURATION_LABEL: Record<Duration, string> = { 60: '1h', 90: '1h30', 120: '2h' }

interface Props {
  value: Duration
  label: string
  onChange: (next: Duration) => void
}

/** How long you want to play. The grid only greens a slot that fits it. */
export function DurationPicker({ value, label, onChange }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className="flex items-center rounded-lg border p-0.5"
      style={{ borderColor: 'var(--border)' }}
    >
      {DURATIONS.map((minutes) => {
        const on = minutes === value
        return (
          <button
            key={minutes}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(minutes)}
            className="nums rounded-md px-2 py-0.5 text-xs font-medium transition-colors"
            style={{
              background: on ? 'var(--surface-2)' : 'transparent',
              color: on ? 'var(--text)' : 'var(--text-faint)',
              boxShadow: on ? 'inset 0 0 0 1px var(--border-strong)' : undefined,
            }}
          >
            {DURATION_LABEL[minutes]}
          </button>
        )
      })}
    </div>
  )
}
